import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Button,
  Checkbox,
  Input,
  Select,
  Option,
  Typography,
} from "@material-tailwind/react";
import CreatableSelect from "react-select/creatable";
import { useSelector, useDispatch } from "react-redux";
import http, { httpForPScreen } from "../../services/http-common";
import * as messages from "../../services/messages";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

import { toast } from "react-toastify";
import {
  getAllAllergies,
  getAllConditions,
  getAllSubstances,
} from "../../store/contraindication/actions";
import EngagingModal from "./EngagingModal";
import ReportDetails from "./ReportDetails";
import { setProfileCheckList } from "../../store/dataFlow/actions";

export default function ScreeningAI() {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { allSubstances, allConditions, allAllergies } = useSelector(
    (state) => state.contraindications
  );
  const { profileCheckList } = useSelector((state) => state.dataFlow);
  const [loading, setLoading] = useState(false);
  const [setIsShowingScreenResult] = useState(false);
  const [screeningTest, setScreeningTest] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [allSearchSubstances, setAllSearchSubstances] = useState(null);
  const [startDate, setStartDate] = useState(new Date("1992"));
  const [selectedGroup, setselectedGroup] = useState(null);
  const [tempProfileCheckList, setTempProfileCheckList] = useState(null);
  const [intakeForm, setIntakeForm] = useState({
    firstName: user?.given_name || "",
    email: user?.email || "",
    phoneNumber: user?.phone_number || "",
    birthYear: "",
    currentMedication: ",",
    knownAllergies: "",
    pastAndCurrentMedicalConditions: "",
    currentMentalHealthStatus: "",
    historyOfSubstanceUse: "",
    previousExperienceWithPsychedelics: "",
    intentionsForPsilocybinUse: "",
    experienceWithEntheogens: "",
    agree: true,
    referralCode: "",
  });

  const errorFunc = (error) => {
    let message;
    switch (error.response.status) {
      case 500: {
        message = messages.SERVER_ERROR;
        break;
      }
      case 404: {
        message = messages.NOT_FOUND_ERROR;
        break;
      }
      case 400: {
        message = messages.BAD_REQUEST;
        break;
      }
      default: {
        message = error.message;
      }
    }
    toast.error(message);
  };

  const onSubmit = () => {
    // console.log(intakeForm);
    setShowResults(true);
    setLoading(true);
    createIntakeForm.mutate();
  };

  const createIntakeForm = useMutation(
    () => {
      return httpForPScreen.post(
        `psiloscreen/intakeform/create`,
        intakeForm,
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        setScreeningTest(data.records);
        handleUpdateCheckList.mutate();
        setLoading(false);
        toast.success("Report Generated Successfully.");
        // navigate("/screening-report");
        setShowResults(false);
        setIsShowingScreenResult(true);
        setIntakeForm({
          firstName: user?.given_name || "",
          email: user?.email || "",
          phoneNumber: user?.phone_number || "",
          birthYear: "",
          currentMedication: ",",
          knownAllergies: "",
          pastAndCurrentMedicalConditions: "",
          currentMentalHealthStatus: "",
          historyOfSubstanceUse: "",
          previousExperienceWithPsychedelics: "",
          intentionsForPsilocybinUse: "",
          agree: true,
        });
      },
      onError: (error) => {
        setLoading(false);
        setIsShowingScreenResult(false);
        setShowResults(false);
        toast.error("Try Again.");
        errorFunc(error);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );
  const getSearchSubstances = useMutation(
    (item) => {
      return httpForPScreen.post(
        `/psiloscreen/substances/search`,
        {
          substanceName: item,
          ps: 500,
          cp: 1,
        },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        let substances = [];
        data?.records?.map((_item) => {
          if (_item.role !== "user") {
            substances.push({
              id: _item.id,
              label: _item.substanceName,
              value: _item.substanceName,
            });
          }
        });
        setAllSearchSubstances(substances);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  const handleChange = (e) => {
    if (loading) return false;
    setIntakeForm({
      ...intakeForm,
      [e.target.name]: e.target.value,
    });
  };

  function handleCurrentMed(values) {
    let newArr = values?.map((obj) => obj.label).join(",");
    setIntakeForm((prevState) => ({
      ...prevState,
      currentMedication: newArr,
    }));
  }

  const handleUpdateCheckList = useMutation(
    () => {
      return http.put(
        `user/seeker-checklist/update`,
        {
          kcId: user.id,
          checkList: tempProfileCheckList,
        },
        null
      );
    },
    {
      onSuccess: ({ data }) => {
        dispatch(setProfileCheckList(tempProfileCheckList));
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
      onMutate: () => {
        setLoading(true);
      },
      onSettled: () => {
        setLoading(false);
      },
    }
  );

  useEffect(() => {
    if (profileCheckList && Array.isArray(profileCheckList)) {
      const updatedCheckList = profileCheckList.map((item) =>
        item.text === "Prescreen with PsiloScreen.me"
          ? { ...item, completed: true }
          : item
      );
      setTempProfileCheckList(updatedCheckList);
    }
  }, [profileCheckList]);

  // const debouncedSearch = debounce((searchTerm) => {
  //   // Perform the search or API call with searchTerm
  //   getSearchSubstances.mutate(searchTerm);
  // }, 500);

  // function handleMedSeach(value) {
  //   // console.log(value);
  //   // debouncedSearch(value);
  // }

  const renderYearContent = (year) => {
    const tooltipText = `${year}`;

    return (
      <>
        <span title={tooltipText}>{year}</span>
      </>
    );
  };

  function handleKonwnAllergies(values) {
    let newArr = values.map((obj) => {
      const { id, label, value, ...rest } = obj;
      return rest;
    });

    setIntakeForm((prevState) => ({
      ...prevState,
      knownAllergies: newArr,
    }));
  }

  function handleAllMedConditions(values) {
    let newArr = values?.map((obj) => obj.label).join(",");
    setIntakeForm((prevState) => ({
      ...prevState,
      pastAndCurrentMedicalConditions: newArr,
    }));
  }

  const handleBirthYear = (value) => {
    setStartDate(value);
    const newDate = new Date(value);
    const year = newDate.getFullYear();
    setIntakeForm({
      ...intakeForm,
      birthYear: year,
    });
  };

  useEffect(() => {
    !allSubstances?.length > 0 && dispatch(getAllSubstances());
    !allConditions?.length > 0 && dispatch(getAllConditions());
    !allAllergies?.length > 0 && dispatch(getAllAllergies());
    getSearchSubstances.mutate("");
    setIntakeForm({
      ...intakeForm,
      firstName: user?.given_name || "",
      email: user?.email || "",
      phoneNumber: user?.phone_number || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <>
      <div className="flex flex-col gap-12">
        {screeningTest ? (
          <ReportDetails screeningTestResult={screeningTest} />
        ) : (
          <Card>
            {showResults && (
              <EngagingModal
                showResults={showResults}
                setShowResults={setShowResults}
              />
            )}
            <CardBody className="p-0 sm:p-6">
              <form className="mt-8 mb-2 ">
                <div className="my-4 flex flex-col sm:flex-row  items-center gap-4">
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Birth Year
                    </Typography>
                    <DatePicker
                      renderCustomHeader={({
                        monthDate,
                        customHeaderCount,
                        decreaseYear,
                        increaseYear,
                      }) => (
                        <div className="flex items-center justify-between px-4 py-2 bg-gray-100 rounded-md">
                          <button
                            type="button" // Prevents form submission
                            aria-label="Previous Year"
                            className="text-gray-600 hover:text-gray-900 focus:outline-none"
                            style={
                              customHeaderCount === 1
                                ? { visibility: "hidden" }
                                : null
                            }
                            onClick={decreaseYear}
                          >
                            <span className="text-lg font-bold">{"<"}</span>
                          </button>
                          <span className="text-gray-800 font-medium">
                            {monthDate.toLocaleString("en-US", {
                              year: "numeric",
                            })}
                          </span>
                          <button
                            type="button" // Prevents form submission
                            aria-label="Next Year"
                            className="text-gray-600 hover:text-gray-900 focus:outline-none"
                            onClick={increaseYear}
                          >
                            <span className="text-lg font-bold">{">"}</span>
                          </button>
                        </div>
                      )}
                      placeholderText="Select Year"
                      selected={startDate}
                      showYearPicker
                      onChange={handleBirthYear}
                      renderYearContent={renderYearContent}
                      className="w-full border border-gray-300 rounded-md px-4 py-2 text-gray-700 bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      dateFormat="yyyy"
                    />
                  </div>
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Current Medications
                    </Typography>
                    {allSearchSubstances && (
                      <CreatableSelect
                        className=""
                        isMulti
                        options={allSearchSubstances}
                        onChange={handleCurrentMed}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            border: "1px solid rgba(176,190,197,1) ",
                            // This line disable the blue border
                            borderRadius: "7px",
                            boxShadow: state.isFocused ? 0 : 0,
                            "&:hover": {
                              border: "2px solid #212121",
                            },
                          }),
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="my-4 flex flex-col sm:flex-row  items-center gap-4">
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Current Medical Conditions
                    </Typography>
                    {allConditions && (
                      <CreatableSelect
                        isMulti
                        options={allConditions}
                        onChange={handleAllMedConditions}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            border: "1px solid rgba(176,190,197,1) ",
                            // This line disable the blue border
                            borderRadius: "7px",
                            boxShadow: state.isFocused ? 0 : 0,
                            "&:hover": {
                              border: "2px solid #212121",
                            },
                          }),
                        }}
                      />
                    )}
                  </div>
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Known Allergies
                    </Typography>
                    {allAllergies && (
                      <CreatableSelect
                        isMulti
                        options={allAllergies}
                        onChange={handleKonwnAllergies}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            border: "1px solid rgba(176,190,197,1) ",
                            // This line disable the blue border
                            borderRadius: "7px",
                            boxShadow: state.isFocused ? 0 : 0,
                            "&:hover": {
                              border: "2px solid #212121",
                            },
                          }),
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="my-4 flex flex-col sm:flex-row  items-center gap-4">
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Experience with Entheogens
                    </Typography>
                    <Input
                      type="text"
                      className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                      value={intakeForm.experienceWithEntheogens}
                      onChange={handleChange}
                      name="experienceWithEntheogens"
                    />
                  </div>
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Substance Use
                    </Typography>
                    <Input
                      value={intakeForm.historyOfSubstanceUse}
                      onChange={handleChange}
                      name="historyOfSubstanceUse"
                      className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                      size="lg"
                    />
                  </div>
                </div>
                <div className="my-4 flex flex-col sm:flex-row  items-center gap-4">
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Level of Support
                    </Typography>
                    <Select
                      value={selectedGroup}
                      className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                      onChange={(v) => {
                        setselectedGroup(v);
                        setIntakeForm({
                          ...intakeForm,
                          levelOfSupport: v.value,
                        });
                      }}
                    >
                      <Option value="not_at_all">Not at all</Option>
                      <Option value="slightly_supported">
                        Slightly supported
                      </Option>
                      <Option value="somewhat_supported">
                        Somewhat supported
                      </Option>
                      <Option value="mostly_supported">Mostly supported</Option>
                      <Option value="very_supported">Very supported</Option>
                    </Select>
                  </div>
                  <div className="w-full">
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="mb-2 font-medium"
                    >
                      Intentions
                    </Typography>
                    <Input
                      value={intakeForm.intentionsForPsilocybinUse}
                      className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                      labelProps={{
                        className: "before:content-none after:content-none",
                      }}
                      onChange={handleChange}
                      name="intentionsForPsilocybinUse"
                      size="lg"
                    />
                  </div>
                </div>
                <div className="mb-4 flex items-center">
                  <Checkbox
                    id="agree"
                    checked={isAgreed}
                    onChange={() => setIsAgreed(!isAgreed)}
                  />
                  <label htmlFor="agree" className="ml-2 text-sm text-gray-700">
                    I agree the{" "}
                    <Link to="/" className="text-blue-500">
                      Terms and Conditions
                    </Link>{" "}
                    and{" "}
                    <Link
                      to="/policies/privacy-policy"
                      className="text-blue-500"
                    >
                      Privacy Policies
                    </Link>
                  </label>
                </div>

                <Button
                  className="mt-6"
                  fullWidth
                  disabled={!isAgreed || loading}
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </form>
            </CardBody>
          </Card>
        )}
      </div>
    </>
  );
}
